import { useState, useCallback, useEffect } from 'react';

// Queues execution of a function until a condition is satisfied
const useExecutionQueue = (callbackArray, executionCondition) => {
  const [queue, updateQueue] = useState([]);

  const addToQueue = item => {
    if (!queue.includes(item)) {
      updateQueue([...queue, item]);
    }
  };
  const emptyQueue = useCallback(() => updateQueue([]), [updateQueue]);

  callbackArray.map((cb, idx) => idx);

  useEffect(() => {
    if (executionCondition && queue.length) {
      queue.forEach(callbackIndex => callbackArray[callbackIndex]());

      emptyQueue();
    }
  }, [callbackArray, executionCondition, queue, emptyQueue]);

  return callbackArray.map((_, idx) => () => addToQueue(idx));
};

export default useExecutionQueue;
